import * as React from 'react';
import LocaleFormating from 'src/translation/localeFormating';

// Models imports
import TrackingModel from 'src/model/trackingInfo.model';

// Style and misc imports
import './TrackingRow.scss';
import { ordersTrackingNumberSel } from 'src/store/modules/orders';

interface ITrackingRowProps {
  t: any;
  tracking: TrackingModel;
}

class TrackingRow extends React.Component<ITrackingRowProps, any> {
  public render() {
    const { t, tracking } = this.props;

    return (
      <div className={`rp-tracking-table--row`}>
        <div className="tracking-data-order-number rp-tracking-table--column">
          <p>{tracking.orderNumber}</p>
        </div>
        <div className="tracking-data-date rp-tracking-table--column">
          <p>{LocaleFormating.formatDate(tracking.orderDate, 'short')}</p>
        </div>
        <div className="tracking-data-confirmation-number rp-tracking-table--column">
          <p>{tracking.confirmationNumber}</p>
        </div>
        <div className="tracking-data-shipped-from rp-tracking-table--column">
          <p>{tracking.shippedFrom}</p>
        </div>
        <div className="tracking-data-shipped-method  rp-tracking-table--column">
          <p>{tracking.shippedMethod}</p>
        </div>
        <div
          className={`rp-tracking-table--column ${
            tracking.trackingLink
              ? 'tracking-data-number-clickable'
              : 'plainText'
          } `}
        >
          {tracking.trackingLink ? (
            <a className="link" href={tracking.trackingLink} target="_blank">
              {tracking.trackNumber}
            </a>
          ) : (
            <p>{tracking.trackNumber}</p>
          )}
        </div>
      </div>
    );
  }
}

export default TrackingRow;
